import * as React from 'react'

function EnvelopeClosedIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={17.4} height={14.4} viewBox="0 0 17.4 14.4" {...props}>
      <g data-name="Group 8293">
        <g
          data-name="Group 7100"
          transform="translate(-1785.3 -355.3) translate(1786 356)"
          fill="none"
          stroke="#263238"
          strokeWidth={1.4}
        >
          <path data-name="Rectangle 3627" d="M0 0H16V13H0z" />
          <path data-name="Path 17178" d="M.5.701l7.808 5.815L15.5.701" strokeLinejoin="round" />
        </g>
      </g>
    </svg>
  )
}

export default EnvelopeClosedIcon
